module.exports = __webpack_public_path__ + "static/media/ag.10d89a6b.png";